const ALLOWED = /^[a-zA-Z0-9@._+-]+$/;

function isEmail(key) {
  return key.includes("@") && key.includes(".") && key.length >= 5;
}

function isColombianPhone(key) {
  const digits = key.replace(/\D/g, "");
  if (key.startsWith("+57") && digits.length === 12) return true;
  return /^\d{10}$/.test(key);
}

function isDocument(key) {
  return /^\d{6,10}$/.test(key);
}

function isAlias(key) {
  if (key.startsWith("@") && key.length >= 2) return true;
  return ALLOWED.test(key);
}

export function validateWallet(value) {
  if (!value || !value.trim()) return "Ingresa tu llave Bre-b";
  const key = value.trim();
  if (key.includes(" ")) return "La llave Bre-b no puede contener espacios";
  if (key.length < 3 || key.length > 64) {
    return "La llave debe tener entre 3 y 64 caracteres";
  }
  if (!ALLOWED.test(key)) return "Caracteres no permitidos en la llave Bre-b";
  if (isEmail(key) || isColombianPhone(key) || isDocument(key) || isAlias(key)) {
    return null;
  }
  return "Ingresa una llave Bre-b válida (celular, correo, cédula o alias)";
}

export function validateForKind(value, kind) {
  if (!value || !value.trim()) return "Completa este campo";
  const key = value.trim();
  switch (kind) {
    case "phone":
      return isColombianPhone(key)
        ? null
        : "Ingresa un celular colombiano de 10 dígitos";
    case "email":
      return isEmail(key) ? null : "Ingresa un correo electrónico válido";
    case "document":
      return isDocument(key) ? null : "Ingresa una cédula de 6 a 10 dígitos";
    case "alias":
      if (!key.startsWith("@") || key.length < 2) {
        return "El alias debe comenzar con @ (ej. @usuario)";
      }
      return ALLOWED.test(key) ? null : "Caracteres no permitidos en el alias";
    default:
      return "Completa este campo";
  }
}

export function validateAccountNumber(value) {
  if (!value || !value.trim()) return "Ingresa el número de cuenta";
  if (!/^\d{8,20}$/.test(value.trim())) {
    return "El número de cuenta debe tener entre 8 y 20 dígitos";
  }
  return null;
}
